import React from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
const GlobalAppNotifications = () => {
  const globalNotifications = PluginStore.exports("globalNotifications").map((notification) => {
    if (!notification.component) {
      console.error('Missing "component" for globalNotification plugin:', notification);
      return null;
    }
    const Component = notification.component;
    if (!notification.key) {
      console.warn('Missing "key" for globalNotification plugin:', notification);
    }
    return /* @__PURE__ */ React.createElement(Component, { key: notification.key });
  }).filter((component) => !!component);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, globalNotifications);
};
export default GlobalAppNotifications;
